module.exports = __webpack_public_path__ + "img/JohnS.d851b2ce.jpg";